<ng-container *ngIf="canSee">
  <app-link [link]="'general.api_qr_code_control_button'" [icon]="'qr_code'" (linkClicked)="showQR()"></app-link>
</ng-container>

<ng-template #qrCodeDialog>
  <app-dialog-header [title]="'general.api_qr_code_control_title'"></app-dialog-header>
  <mat-dialog-content>
    <div class="body-2" [innerHTML]="authService.ticketControlHtml | translate"></div>
    <app-loader class="top-spacer bottom-spacer" [loading]="isLoading" [size]="16"></app-loader>
    <div class="align-center">
      <img class="qr-code" [alt]="eventId" *ngIf="!isLoading" [src]="svg" />
      <app-label-value [value]="eventName" [label]="'general.api_qr_code_control_event_name'"></app-label-value>
      <app-label-value [value]="eventId" [label]="'general.api_qr_code_control_event_id'"></app-label-value>
    </div>
  </mat-dialog-content>
  <app-dialog-footer [dialogActions]="modalButtonsTemplate"></app-dialog-footer>
  <ng-template #modalButtonsTemplate>
    <button mat-button mat-dialog-close>
      {{ 'general.api_general_close' | translate }}
    </button>
  </ng-template>
</ng-template>
